module.exports = __webpack_public_path__ + "static/media/boss_empty.9af375f0.svg";